import Swal, { SweetAlertIcon } from "sweetalert2";

export const sweetAlert = (message: string, error: SweetAlertIcon) => {
  return Swal.fire(error.toLocaleUpperCase(), message, error!);
};
